import * as angular from 'angular';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsCommands } from "../../shared/dto/aps.commands";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";

export interface CommodityBinService {
  get(plantId: string, tankId: string): angular.IPromise<apsViewModels.CommodityBinMapping[]>;
  update(command: apsCommands.UpdateCommodityBinMapping): angular.IPromise<any>;
}

class CommodityBinSvc implements CommodityBinService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  get(plantId: string, tankId: string): angular.IPromise<apsViewModels.CommodityBinMapping[]> {
    return this.httpService.get<apsViewModels.CommodityBinMapping[]>(Endpoints.COMMODITY_BIN, { plantId, tankId });
  }

  update(command: apsCommands.UpdateCommodityBinMapping): angular.IPromise<any> {
    return this.httpService.put(Endpoints.COMMODITY_BIN, command);
  }
}

export default angular
  .module('aps.services.commodityBin', [HttpServiceName])
  .service('commodityBinService', CommodityBinSvc)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/batches/commodityBin.service.ts